import createLoadablePage from 'utils/createLoadablePage';

const PromotionTermsApp = createLoadablePage(
  () => import(/* webpackChunkName: "app-promotion-terms" */ './Routes'),
);

export default PromotionTermsApp;
